import { Injectable } from '@angular/core';
import * as pako from 'pako';
import { MensagemService } from './mensagem.service';
import { UrlImportacaoService } from './url-importacao.service';

@Injectable({
  providedIn: 'root'
})
export class DataCompressionService {

  constructor(
    private mensagemService: MensagemService,
    private urlImportacaoService: UrlImportacaoService
  ) { }

  /**
   * Compress data and encode to URL-safe base64
   */
  compressToUrlSafe(data: any): string {
    try {
      const jsonString = JSON.stringify(data);
      const uint8Array = new TextEncoder().encode(jsonString);
      const compressed = pako.gzip(uint8Array);
      const base64 = btoa(String.fromCharCode(...compressed));
      // Make URL-safe by replacing characters
      return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    } catch (error) {
      this.mensagemService.mostrar('Erro', 'Erro', 'Erro na compressão dos dados');
      throw new Error('Erro na compressão dos dados');
    }
  }

  /**
   * Decompress URL-safe base64 data
   */
  decompressFromUrlSafe(compressedData: string): any {
    try {
      // Restore base64 padding and characters
      let base64 = compressedData.replace(/-/g, '+').replace(/_/g, '/');
      const padding = base64.length % 4;
      if (padding) {
        base64 += '='.repeat(4 - padding);
      }
      
      const binaryString = atob(base64);
      const uint8Array = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      
      const decompressedBytes = pako.ungzip(uint8Array);
      const decompressed = new TextDecoder('utf-8').decode(decompressedBytes);
      return JSON.parse(decompressed);
    } catch (error) {
      this.mensagemService.mostrar('Erro', 'Erro', 'Link inválido');
      this.urlImportacaoService.limparParametroImportDaUrl();
      throw new Error('Erro na descompressão dos dados');
    }
  }

  /**
   * Generate shareable URL with compressed data
   */
  generateShareableUrl(data: any, href: string): string {
    const compressed = this.compressToUrlSafe(data);
    href = href || window.location.href;
    return `${href}?import=${compressed}`;
  }

  extractDataFromUrl(url: string = window.location.href): any | null {
    try {
      const urlObj = new URL(url);
      const importParam = urlObj.searchParams.get('import');
      
      if (!importParam) {
        return null;
      }
      
      return this.decompressFromUrlSafe(importParam);
    } catch (error) {
      console.error('Erro ao extrair dados da URL:', error);
      return null;
    }
  }

  getCompressionStats(data: any): { original: number; compressed: number; ratio: string } {
    const original = JSON.stringify(data).length;
    const compressed = this.compressToUrlSafe(data).length;
    const ratio = ((1 - compressed / original) * 100).toFixed(1);
    
    return {
      original,
      compressed,
      ratio: `${ratio}%`
    };
  }
}